import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import * as con from "../Constants"
import * as types from "./types"


const initialState = {

    // Store initial values
    [con.SELECTED_DATABASE]: con.DATABASE_ITS,
    [con.SELECTED_METHOD]: null,
    [con.STORAGE_CURRENT_LOCAL]: con.EN,

    // User interface and sequence status
    [con.INPUT_TEXT_SEQUENCE_STATUS]: con.STATUS_IS_MISSING,
    [con.INPUT_TEXT_SEQUENCE_MESSAGE]: null,
    [con.INPUT_TEXT_SEQUENCE_MESSAGE_CONTEXT]: {},
    [con.UPLOADED_FILE_SEQUENCE_STATUS]: con.STATUS_IS_MISSING,
    [con.UPLOADED_FILE_SEQUENCE_MESSAGE]: null,
    [con.UPLOADED_FILE_SEQUENCE_MESSAGE_CONTEXT]: null,
    [con.PROCESSING_SEQUENCE_MESSAGE]: null,
    [con.SERVER_STATUS]: con.STATUS_NOT_STARTED,


    // Input sequences and uploaded files
    [con.INPUT_TEXT_SEQUENCE]: null,
    [con.UPLOADED_FILE_NAME]: null,

    // Annotation results and queries
    [con.ANNOTATION_RESULT_DATA]: null,
    [con.SELECTED_ANNOTATION_QUERY_ID]: null,
    [con.SELECTED_ALIGNMENT_RESULT_HIT_ID]: null,

    // Job information (also used for bug reports)
    [con.CURRENT_FILE_ID]: null,
    [con.CURRENT_JOB_ID]: null,

    // Experimental Environment
    [con.IS_EXPERIMENTAL] : false,



};

const rootReducer = (state = initialState, action) => {

    let val, key, keyValueDict

    switch (action.type) {
        case types.SET_VALUE_IN_STORAGE:
            val = action.payload[con.VALUE]
            key = action.payload[con.KEY]

            // Main Implication Function
            // Here should be stored all logic regarding the implication that a change in one stored variable implies another
            switch (key) {
                case con.SELECTED_ANNOTATION_QUERY_ID:
                    state = {
                        ...state,
                        [con.SELECTED_ALIGNMENT_RESULT_HIT_ID]: null
                    }
                    break;
                case con.ANNOTATION_RESULT_DATA:
                    state = {
                        ...state,
                        [con.SELECTED_ANNOTATION_QUERY_ID]: null,
                        [con.SELECTED_ALIGNMENT_RESULT_HIT_ID]: null
                    }
                    break
                default:
                    break;
            }


            state = {
                ...state,
                [key]: val,
            };

            break
        case types.SET_MULTIPLE_VALUES_IN_STORAGE:
            keyValueDict = action.payload[con.KEY_VALUE_DICT]

            state = {
                ...state,
                ...keyValueDict
            };


            break

        default:
            break

    }
    return state
}


const persistConfig = {
    key: 'root/eutax',
    storage: storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)


export const store = configureStore({
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST']
            },
            immutableCheck: true
        }),
    reducer: persistedReducer
})

export const persistor = persistStore(store)


